import useDispensary from 'src/dispensary/hooks/use-dispensary';

export const useHideSalesLanguage = (): boolean => {
  const { dispensary } = useDispensary();

  return dispensary?.storeSettings?.restrictSalesLanguage ?? false;
};
